import {
    Row,
    Col,
    Typography,
    Table,
    Button,
    message,
  } from "antd";
  import { routes } from "common/routes";
  import { generateHeaders, getSlotName } from "common/utils";
  import { AppPageHeader } from "components/AppPageHeader";
  import { useAppDispatch } from "hooks/useAppDispatch";
  import { useAppSelector } from "hooks/useAppSelector";
  import { useDocumentTitle } from "hooks/usePageTitle";
  import { useEffect, useMemo } from "react";
  import { useNavigate } from "react-router-dom";
import { cancelFranchiseMapping, removeProcessingFranchiseMapping, saveFranchiseMapping } from "store/franchise/franchiseSlice";
  
  const MESSAGE_KEY = "SAVE_FRANCHISE_MAPPING";
  
  export const FranchiseMappingSavePage = () => {
    useDocumentTitle("Save Franchise Inventory");
    const { processingFranchiseMapping, status, error } = useAppSelector(
      (state) => state.franchiseServices
    );
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (
    //         processingFranchiseMapping &&
    //         processingFranchiseMapping.key
    //     ) {
    //       navigate(`/${routes.PPD.SAVE}`, {});
    //     }
    
    //     return () => {
    //       message.destroy();
    //     };
    //   }, [processingFranchiseMapping, navigate]);
  
    useEffect(() => {
      const { timeUploaded } = processingFranchiseMapping;
      if (timeUploaded) {
        const uploadedTime = new Date(timeUploaded).getTime();
        const currentTime = new Date().getTime();
        const minsPassed = (currentTime - uploadedTime) / 1000 / 60;
  
        if (minsPassed >= 15) {
          dispatch(removeProcessingFranchiseMapping());
        }
      }
  
      if (!Object.keys(processingFranchiseMapping).length) { 
        navigate(`/${routes.FRANCHISE.UPLOAD}`);
      }
    }, [dispatch, processingFranchiseMapping, navigate]);

    useEffect(() => {
      if (status === "loading") {
        message.loading({ content: "saving upload", key: MESSAGE_KEY });
      } else if (status === "success") {
        message.success({
          content: "Franchise Inventory saved!",
          duration: 5,
          key: MESSAGE_KEY,
        });
      } else if (status === "cancelling") {
        message.loading({ content: "cancelling upload", key: MESSAGE_KEY });
      } else if (status === "error") {
        message.error({ content: error, key: MESSAGE_KEY });
      }
  
      return () => {
        message.destroy();
      };
    }, [status, error]);
  
    let content;
    const { headerMapping } = processingFranchiseMapping;
    const { Text } = Typography;
  
    const generateMemoizedHeaders = useMemo(
      () => generateHeaders(headerMapping),
      [headerMapping]
    );
  
    const onSaveRequisition = () => {
      dispatch(saveFranchiseMapping());
    };
  
    const onCancelSave = () => {
      dispatch(cancelFranchiseMapping());
    };
  
    if ((processingFranchiseMapping.success) === 0) {
      content = <Text>Nothing to show here!</Text>;
    } else {
      const headers = generateMemoizedHeaders || {};
      const successRows = processingFranchiseMapping.successRows;
      const data = successRows?.map((row, i) => ({ ...row, key: `data-${i}` }));
      const columns = [
        ...Object.keys(headers).map(
          (key) =>
            ({
              key,
              title: headers[key],
              dataIndex: key,
            } as any)
        ),
      ];
      content = (
        <Table
          size="small"
          columns={columns}
          dataSource={data}
          scroll={{ y: 500, x: "100vh" }}
          summary={() => (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={24}>
                  <Row>
                    <Col>
                      <Button
                        type="primary"
                        onClick={onSaveRequisition}
                        loading={status === "loading"}
                        disabled={status === "loading"}
                      >
                        Save Requisition
                      </Button>
                    </Col>
                    <Col style={{ justifyContent: "left", marginLeft: "20px" }}>
                      <Button
                        onClick={onCancelSave}
                        disabled={status === "loading"}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        ></Table>
      );
    }
  
    return (
      <>
        <Row>
          <Col>
            <AppPageHeader title="Save Picker Packer Mapping" />
          </Col>
        </Row>
        <Row>
          <Col xs={24}>{content}</Col>
        </Row>
      </>
    );
  };
  